export default {
  VISIT_TYPE_FILTER_HIDE: 'CALENDAR.VISIT_TYPE_FILTER_HIDE',
  VISIT_TYPE_FILTER_SHOW: 'CALENDAR.VISIT_TYPE_FILTER_SHOW',
  VISIT_TYPE_FILTER_CHANGE: 'CALENDAR.VISIT_TYPE_FILTER_CHANGE',
}
